module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Create range","rangesActionsCreateSuccess":"%{rangesName} was successfully added to the database"},"no":{"dialogTitle":"Opprett skyttebane","rangesActionsCreateSuccess":"%{rangesName} ble lagt til i databasen"}}')
  delete Component.options._Ctor
}
